import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=d6b519c0&scoped=true"
import script from "./Ward.vue?vue&type=script&lang=js"
export * from "./Ward.vue?vue&type=script&lang=js"
import style0 from "./Ward.vue?vue&type=style&index=0&id=d6b519c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b519c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6b519c0')) {
      api.createRecord('d6b519c0', component.options)
    } else {
      api.reload('d6b519c0', component.options)
    }
    module.hot.accept("./Ward.vue?vue&type=template&id=d6b519c0&scoped=true", function () {
      api.rerender('d6b519c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Ward.vue"
export default component.exports